export default {
    'pointList.kc': '库存',
    'pointList.lgkc': '冷柜库存',
    'pointList.tlkc': '调料柜库存'
}
